import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { Grid, Tab, AppBar, Tabs } from '@mui/material';
import TabPanel from 'components/Common/TabPanel';
import { GlobalContext } from 'providers/GlobalProvider';
import ContentLayout from 'components/Common/ContentLayout';
import GroupAPI from 'api/GroupAPI';
import { useSnackbar } from 'notistack';
import ActiveTeams from 'components/SuperAdmin/ActiveTeams';
import ArchivedTeams from 'components/SuperAdmin/ArchivedTeams';

const a11yProps = (index: number) => {
  return {
    'id': `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

export interface IKeycloakTeam {
  id: string,
  name: string,
  path: string,
  subGroups: string[]
  realmRoles: string[]
}

const TeamAccess = (): any => {
  const archivedID = process.env.REACT_APP_ARCHIVED_ID!;
  const { cur_user } = useContext(GlobalContext);
  const { enqueueSnackbar } = useSnackbar();
  const [ value, setValue ] = useState<number>(0);
  const history = useHistory();
  const [ allGroups, setAllGroups ] = useState<IKeycloakTeam[]>([]);

  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  const addClass = () => {
    document.getElementById('ThemeTabs')?.classList.toggle('TabItem-3');
  };

  const archiveTeam = async(teamId: string, teamName: string) => {
    const archivedTeamResp = await GroupAPI.addRoleToGroup(teamId, archivedID, 'archived');
    if (archivedTeamResp?.success) {
      enqueueSnackbar(`Successfully archived team ${teamName}`, { variant: 'success' });
      // refresh page so changes take place on UI
      history.go(0);
    } else{
      const err_text = `Error archiving team: ${archivedTeamResp?.result}`;
      enqueueSnackbar(err_text, { variant: 'error' });
    };
  };

  const activateTeam = async(teamId: string, teamName: string) => {
    const activatedTeamResp = await GroupAPI.removeRoleFromGroup(teamId, archivedID, 'archived');
    if (activatedTeamResp?.success) {
      enqueueSnackbar(`Successfully activated team ${teamName}`, { variant: 'success' });
      // refresh page so changes take place on UI
      history.go(0);
    } else{
      const err_text = `Error activating team: ${activatedTeamResp?.result}`;
      enqueueSnackbar(err_text, { variant: 'error' });
    };
  };

  const getListOfGroupsAndFilter = () => {
    GroupAPI.getGroupsForAdmin().then((teamResp) => {
      if (teamResp?.success) {
        const filteredTeams = teamResp.result.filter((team: any) => team.name === 'User Teams');
        setAllGroups(filteredTeams[0].subGroups);
      }
    });
  };

  useEffect(() => {
    getListOfGroupsAndFilter();
  }, []);

  if (cur_user.bite_super_admin === false) {
    return <Redirect to='/' />;
  }
  return (
    <ContentLayout title='List of Teams in Bite 2.0'>
      <Grid item xs={12}>
        <AppBar position='static' className='Tab-Appbar'>
          <Tabs
            className='ThemeTabs'
            id='ThemeTabs'
            value={value}
            onChange={handleChange}
            aria-label=''
          >
            <Tab onClick={addClass} label='Active' {...a11yProps(0)} />
            <Tab onClick={addClass} label='Archived' {...a11yProps(1)} />
          </Tabs>
        </AppBar>

        <TabPanel value={value} index={0} className='Tab-Body'>
          <Grid container>
            <ActiveTeams teams={allGroups} archiveTeam={archiveTeam}/>
          </Grid>
        </TabPanel>

        <TabPanel value={value} index={1} className='Tab-Body'>
          <Grid container>
            <ArchivedTeams teams={allGroups} activateTeam={activateTeam} />
          </Grid>
        </TabPanel>
      </Grid>
    </ContentLayout>
  );
};

export default TeamAccess;
